import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_GET_HALAL_STOCK } from "../../../config/api";
import { getStock } from "./getStock";

export const configurePurification = createAsyncThunk(
  "stocks/configurePurification",
  async ({ id, data, callback }, { dispatch, rejectWithValue }) => {
    try {
      const response = await Client({
        method: "PUT",
        path: API_GET_HALAL_STOCK + id,
        data: data,
      });
      toast.success("Purification settings updated successfully");
      dispatch(getStock(id));
      callback && callback();
      return response?.data?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      return rejectWithValue(error.message);
    }
  }
);
